module.exports = __webpack_public_path__ + "static/img/carac1.c1ea1dc4.jpg";